import React from 'react';

import { Box, Divider, SxProps, Theme, Typography } from '@mui/material';

import { GUIDE_TEXT_MAX_WIDTH } from './guidePage.constants';

type SectionHeaderProps = Readonly<{
  title: string;
  subtitle?: string;
  rightSlot?: React.ReactNode;
  hideDivider?: boolean;
}>;

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  rightSlot,
  hideDivider,
}) => (
  <>
    <Box sx={rowSx}>
      <Box sx={textSx}>
        <Typography variant="display-xs-semibold">{title}</Typography>
        {subtitle && (
          <Typography
            variant="text-sm-regular"
            color={({ backrs }) => backrs.colors['Colors/Text/text-tertiary']}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
      {rightSlot}
    </Box>
    {!hideDivider && (
      <Box sx={dividerSx}>
        <Divider sx={dividerLineSx} />
      </Box>
    )}
  </>
);

const rowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: backrs.spacing['spacing-md'],
  '@container (min-width: 600px)': {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: backrs.spacing['spacing-xl'],
  },
});

const textSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
  maxWidth: GUIDE_TEXT_MAX_WIDTH,
});

const dividerSx: SxProps<Theme> = ({ backrs }) => ({
  pt: backrs.spacing['spacing-2xl'],
  pb: backrs.spacing['spacing-3xl'],
});

const dividerLineSx: SxProps<Theme> = ({ backrs }) => ({
  backgroundColor: backrs.colors['Gray/700'],
});
